// extracted by mini-css-extract-plugin
export default {"errorRow":"fa913d22"};